// extracted by mini-css-extract-plugin
export var enTitle = "PageTitle-module--en-title--81e8c";
export var title = "PageTitle-module--title--05783";